<template>
  <b-col md="12" sm="12">
    <b-card no-body>
    <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Alterar Moção</h1>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Título:">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Título"
                                autocomplete="titulo"
                                v-model="$v.form.titulo.$model"
                                :state="chkState('titulo')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="table-responsive" cols="12">
              <b-form-group label="Descrição:" :state="chkState('descricao')">
                <wysiwyg v-model="form.descricao" :state="chkState('descricao')"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="table-responsive" cols="12">
              <b-form-group label="Moção:" :state="chkState('mocao')">
                <wysiwyg v-model="form.mocao" :state="chkState('mocao')"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Selecione o Perfil e Ações:">
              </b-form-group>
            </b-col>        
            <b-col v-for="perfil in perfis" :key="perfil.value" sm="3">
                    <b-form-checkbox class='check'                 
                      :value="perfil.value"
                      v-model="perfis_selecionados[perfil.value]">
                      {{ perfil.text }}
                    </b-form-checkbox>
                    <b-form-checkbox-group                
                      v-model="acoes_selecionadas[perfil.value]"
                      v-for="acoes in sub_acoes"
                      :key="acoes.value"> 
                    <b-form-checkbox :disabled="perfis_selecionados[perfil.value] == undefined || perfis_selecionados[perfil.value] == false" class='groupCheck' :value="acoes.value">{{acoes.text}}</b-form-checkbox>
                    </b-form-checkbox-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="4">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-pencil"></i>&nbsp;
              <span>Alterar Moção</span>
            </b-button>
          </b-col>
          <b-col v-else md="4">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/mocao')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
      },
      mocao: {
        required
      }
    }
  },
  created () {  
    this.loadMocao(this.$route.params.id)
    this.carregarPerfis()
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        descricao: '',
        mocao: ''
      },
      perfis: [],  
      perfis_selecionados: [],
      acoes_selecionadas: [],
      sub_acoes: [
        {value: 'V', text: 'Visualizar'},  
        {value: 'A', text: 'Votação'}, 
        {value: 'P', text: 'Priorização'}
      ],
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    loadMocao (id) {
      Vue.http.get('api/mocao/' + id).then(response => {
        let data = response.body.data
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.form.mocao = data.mocao
        let perfis = []
        let acoes_perfil = []
        let dados_acao = []
        if(data.perfil_acoes){
           $.each(data.perfil_acoes, function(index) {     
              let perfil_id = data.perfil_acoes[index].perfil_id       
              perfis[perfil_id] = perfil_id
               
             if(data.perfil_acoes[index].priorizacao == true){
                acoes_perfil[0] = 'P'
             }
             if(data.perfil_acoes[index].votacao == true){
                acoes_perfil[1] = 'A'
             }          
             if(data.perfil_acoes[index].visualizacao == true){
                acoes_perfil[2] = 'V'
             }

             dados_acao[perfil_id] = acoes_perfil 
             acoes_perfil = []
          }) 
        }   
       
        this.acoes_selecionadas = dados_acao
        this.perfis_selecionados = perfis   
      })
    },
    salvar () {
      let form = this.$v.form
      let data = {
        titulo: form.titulo.$model,
        descricao: form.descricao.$model,
        mocao: form.mocao.$model,
        perfil_acoes: this.acoes_selecionadas
      }
      this.loading = true

      Vue.http.put('api/mocao/' + this.$route.params.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/mocao'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        console.log('Servidor está fora! ' + e)
      })
    },
    carregarPerfis () {    
      Vue.http.post('api/perfil/index', {status: true}).then(response => {
        if (response.body.success) {
          let perfis = response.body.data
          for (let i = 0; i < perfis.length; i++) {
            this.perfis.push({value: perfis[i].id, text: perfis[i].nome})
          }
        }
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>
<style scoped>
.groupCheck {
  margin-left: 16px;
}
.check{
  margin-top: 8px;
  font-weight: bold;
}

.editr .editr--toolbar div .vw-btn-table {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/mocao/MocaoEditar.vue